import React, { TableHTMLAttributes } from 'react';
import classNames from 'classnames';

export interface TableProps extends TableHTMLAttributes<HTMLTableElement> {
  children: React.ReactNode;
  borderless?: boolean;
}

const Table = ({ children, className, borderless = false, ...rest }: TableProps): JSX.Element => (
  <table
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...rest}
    className={classNames(
      'usa-table',
      {
        'usa-table--borderless': borderless,
      },
      className,
    )}
  >
    {children}
  </table>
);

export default Table;
